import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentTypeItemQueryVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type GetAppointmentTypeItemQuery = {
  __typename?: "Query";
  getAppointmentTypeItem: {
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
    duration: number;
    memberStatus: string | null;
    minimumSchedulingNotice: number;
    bufferBeforeAppointment: number | null;
    bufferAfterAppointment: number | null;
    availabilityIncrements: number | null;
    hasNextSteps: boolean | null;
    nextStepsLabel: string | null;
    nextStepsUrl: string | null;
    lateCancel: number;
    sendEmailNotification: boolean;
    emailNotificationSubject: string | null;
    message: string | null;
    notifyStaffMember: boolean | null;
    sendEmailReminder: boolean;
    emailReminderTiming: number | null;
    emailReminderSubject: string | null;
    emailReminderMessage: string | null;
    sendTextReminder: boolean;
    textReminderTiming: number;
    textReminderMessage: string | null;
    staff: Array<{
      __typename?: "Staff";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
    } | null>;
    availability: Array<{
      __typename?: "AppointmentAvailability";
      dayOfTheWeek: string;
      startTime: string;
      endTime: string;
    } | null>;
  };
};

export type AppointmentTypeItemFragment = {
  __typename?: "AppointmentType";
  uuid: string;
  name: string;
  color: string;
  duration: number;
  memberStatus: string | null;
  minimumSchedulingNotice: number;
  bufferBeforeAppointment: number | null;
  bufferAfterAppointment: number | null;
  availabilityIncrements: number | null;
  hasNextSteps: boolean | null;
  nextStepsLabel: string | null;
  nextStepsUrl: string | null;
  lateCancel: number;
  sendEmailNotification: boolean;
  emailNotificationSubject: string | null;
  message: string | null;
  notifyStaffMember: boolean | null;
  sendEmailReminder: boolean;
  emailReminderTiming: number | null;
  emailReminderSubject: string | null;
  emailReminderMessage: string | null;
  sendTextReminder: boolean;
  textReminderTiming: number;
  textReminderMessage: string | null;
  staff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  } | null>;
  availability: Array<{
    __typename?: "AppointmentAvailability";
    dayOfTheWeek: string;
    startTime: string;
    endTime: string;
  } | null>;
};

export type GetStaffForAppointmentTypeQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetStaffForAppointmentTypeQuery = {
  __typename?: "Query";
  getStaff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  } | null>;
};

export type StaffForAppointmentTypeFragment = {
  __typename?: "Staff";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
};

export const AppointmentTypeItemFragmentDoc = gql`
  fragment AppointmentTypeItem on AppointmentType {
    uuid
    name
    color
    duration
    memberStatus
    staff(filter: { priorStaff: true }) {
      userUuid
      firstName
      lastName
    }
    availability {
      dayOfTheWeek
      startTime
      endTime
    }
    minimumSchedulingNotice
    bufferBeforeAppointment
    bufferAfterAppointment
    availabilityIncrements
    hasNextSteps
    nextStepsLabel
    nextStepsUrl
    lateCancel
    sendEmailNotification
    emailNotificationSubject
    message
    notifyStaffMember
    sendEmailReminder
    emailReminderTiming
    emailReminderSubject
    emailReminderMessage
    sendTextReminder
    textReminderTiming
    textReminderMessage
  }
`;
export const StaffForAppointmentTypeFragmentDoc = gql`
  fragment StaffForAppointmentType on Staff {
    userUuid
    firstName
    lastName
  }
`;
export const GetAppointmentTypeItemDocument = gql`
  query GetAppointmentTypeItem($uuid: String!) {
    getAppointmentTypeItem(uuid: $uuid) {
      ...AppointmentTypeItem
    }
  }
  ${AppointmentTypeItemFragmentDoc}
`;

/**
 * __useGetAppointmentTypeItemQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypeItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypeItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypeItemQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAppointmentTypeItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppointmentTypeItemQuery,
    GetAppointmentTypeItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentTypeItemQuery,
    GetAppointmentTypeItemQueryVariables
  >(GetAppointmentTypeItemDocument, options);
}
export function useGetAppointmentTypeItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentTypeItemQuery,
    GetAppointmentTypeItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentTypeItemQuery,
    GetAppointmentTypeItemQueryVariables
  >(GetAppointmentTypeItemDocument, options);
}
export type GetAppointmentTypeItemQueryHookResult = ReturnType<
  typeof useGetAppointmentTypeItemQuery
>;
export type GetAppointmentTypeItemLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentTypeItemLazyQuery
>;
export type GetAppointmentTypeItemQueryResult = Apollo.QueryResult<
  GetAppointmentTypeItemQuery,
  GetAppointmentTypeItemQueryVariables
>;
export const GetStaffForAppointmentTypeDocument = gql`
  query GetStaffForAppointmentType {
    getStaff {
      ...StaffForAppointmentType
    }
  }
  ${StaffForAppointmentTypeFragmentDoc}
`;

/**
 * __useGetStaffForAppointmentTypeQuery__
 *
 * To run a query within a React component, call `useGetStaffForAppointmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffForAppointmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffForAppointmentTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffForAppointmentTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStaffForAppointmentTypeQuery,
    GetStaffForAppointmentTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStaffForAppointmentTypeQuery,
    GetStaffForAppointmentTypeQueryVariables
  >(GetStaffForAppointmentTypeDocument, options);
}
export function useGetStaffForAppointmentTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStaffForAppointmentTypeQuery,
    GetStaffForAppointmentTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStaffForAppointmentTypeQuery,
    GetStaffForAppointmentTypeQueryVariables
  >(GetStaffForAppointmentTypeDocument, options);
}
export type GetStaffForAppointmentTypeQueryHookResult = ReturnType<
  typeof useGetStaffForAppointmentTypeQuery
>;
export type GetStaffForAppointmentTypeLazyQueryHookResult = ReturnType<
  typeof useGetStaffForAppointmentTypeLazyQuery
>;
export type GetStaffForAppointmentTypeQueryResult = Apollo.QueryResult<
  GetStaffForAppointmentTypeQuery,
  GetStaffForAppointmentTypeQueryVariables
>;
